import { configureStore } from '@reduxjs/toolkit';
import personReducer from './slices/personSlice';

// Debug middleware
const actionDebugMiddleware = store => next => action => {
  console.log(' Action Received:', {
    type: action.type,
    isFunction: typeof action === 'function',
    actionKeys: Object.keys(action),
    action: action
  });

  try {
    const result = next(action);
    
    // Log dello stato dopo ogni azione
    console.log(' State after action:', {
      actionType: action.type,
      newState: store.getState()
    });
    
    return result;
  } catch (error) {
    console.error(' Error in middleware:', error);
    throw error;
  }
};

// Thunk debug middleware
const thunkDebugMiddleware = store => next => action => {
  if (typeof action === 'function') {
    console.log(' Thunk action received:', action.name || 'anonymous');
  }
  return next(action);
};

export const store = configureStore({
  reducer: {
    person: personReducer
  },
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware({
      serializableCheck: false
    });
    
    console.log(' Configuring middleware:', {
      defaultMiddleware: middleware.map(m => m.name || 'unnamed'),
      customMiddleware: ['actionDebugMiddleware', 'thunkDebugMiddleware']
    });
    
    return middleware
      .concat(thunkDebugMiddleware)
      .concat(actionDebugMiddleware);
  },
  devTools: process.env.NODE_ENV !== 'production'
});

// Log initial state
console.log(' Initial Redux State:', store.getState());

// Subscribe to state changes
store.subscribe(() => {
  const state = store.getState();
  console.log(' Redux State Updated:', {
    person: state.person
  });
});

// Enable Redux DevTools
if (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION__) {
  window.__REDUX_DEVTOOLS_EXTENSION__.connect();
}
